module.exports = __webpack_public_path__ + "static/media/person-booth.4f4cfc04.svg";